import type { QuotationItemApi } from 'api-typings/quotations/quotations';
import { QuotationItemUnitTypeApi } from 'api-typings/quotations/quotations';
import {
  type QuotationItemRevision,
  QuotationItemType,
} from './quotation-item-revisions.model';

export function transformQuotationItemRevision(
  quotationItem: QuotationItemApi,
): QuotationItemRevision {
  return {
    id: quotationItem.item_version_id,
    quotationItemId: quotationItem.id,
    quotationId: quotationItem.quotation_id,
    name: quotationItem.name,
    createDate: quotationItem.create_date,
    order: quotationItem.order,
    currencyId: quotationItem.currency_id || 1,
    paidAmount: quotationItem.paid_amount || 0,
    fundedAmount: quotationItem.funded_amount || 0,
    unitPrice: quotationItem.unit_price || 0,
    quantity: quotationItem.quantity || 0,
    description: quotationItem.description || '',
    message: quotationItem.message,
    invalidDate: quotationItem.invalid_date,
    versionInvalidDate: quotationItem.version_invalid_date,
    completeDate: quotationItem.complete_date,
    quotationVersionId: quotationItem.quotation_version_id,
    unitType:
      (quotationItem.unit_type as QuotationItemUnitTypeApi) || undefined,
    originalQuotationVersionId: quotationItem.original_quotation_version_id,
    status: quotationItem.status,
    totalPrice: calculateTotal(
      quotationItem.quantity,
      quotationItem.unit_price,
    ),
    unitLimit: quotationItem.unit_limit,
    billingFrequency: quotationItem.billing_frequency,
    quotationItemType: transformQuotationItemType(quotationItem),
  };
}

function calculateTotal(quantity?: number, unitPrice?: number): number {
  return (quantity ?? 0) * (unitPrice ?? 0);
}

function transformQuotationItemType(
  quotationItem: QuotationItemApi,
): QuotationItemType {
  if (quotationItem.unit_type === QuotationItemUnitTypeApi.HOUR) {
    return QuotationItemType.HOURLY;
  }
  if (quotationItem.billing_frequency) {
    return QuotationItemType.SUBSCRIPTION;
  }
  return QuotationItemType.FIXED;
}
